module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/gifs/email-integration-2-log.gif"